const Logo = (props) => {

    return <>

        <img className={`${props.small ? 'max-w-[50px] mx-auto' : 'max-w-[200px] mx-auto'} ${props?.animate && props.animate ? "zoom-animation" : ""}`} src={"/logo.png"} alt="" />
    </>
}

export default Logo;